import classNames from 'classnames';
import moment from 'moment';
import React, {Fragment} from 'react';
import DatePicker from 'react-datepicker';
import {connect} from 'react-redux';
import {fetchLeagueIfNeeded} from '../../../../../../../actions/app/support/league';
import {getEndpoint, getHeaders} from '../../../../../../../helpers/endpoint';
import {copyTextToClipboard} from '../../../../../../../helpers/utils';
import TableRow from '../../../../../components/TableRow';
import SupportTitle from '../../../../../components/title';
import {UserInfoStyles} from '../../../../../User/components/Info/styles';
import DivisionInfos from '../../../DivisionInfos';
import DivisionPlayers from '../../../DivisionPlayers';
import DivisionPurchases from '../../../DivisionPurchases';
import LeagueUsers from '../../../LeagueUsers';

export const setLeagueImageToDefault = payload => {
  return (dispatch, getState) => {
    fetch(getEndpoint('setLeagueImageToDefault', payload.leagueId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({lockImageUrl: Boolean(payload.lockImageUrl)}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchLeagueIfNeeded(payload.leagueId));
        }
      });
  };
};

export const changeLeagueRating = payload => {
  return (dispatch, getState) => {
    fetch(getEndpoint('changeLeagueRating', payload.leagueId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({rating: payload.rating}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchLeagueIfNeeded(payload.leagueId));
        }
      });
  };
};

export const changeMercatoStartDate = payload => {
  return (dispatch, getState) => {
    fetch(getEndpoint('changeMercatoStartDate', payload.leagueId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({mercatoStartDate: payload.mercatoStartDate}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchLeagueIfNeeded(payload.leagueId));
        }
      });
  };
};

export const changeMercatoInAuto = payload => {
  return (dispatch, getState) => {
    fetch(getEndpoint('changeMercatoInAuto', payload.leagueId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchLeagueIfNeeded(payload.leagueId));
        }
      });
  };
};

const MercatoTableRows = ({
  entity,
  dispatch,
  onSelectDivision,
  selectedDivision,
}) => {
  if (entity.status !== 3) {
    return null;
  }
  return (
    <Fragment>
      <TableRow
        label="mercatoStartDate"
        value={entity?.gameSettings?.mercatoStartDate}
        action={
          <div id="CollectionsList" style={{position: 'relative'}}>
            <DatePicker
              style={{width: 200}}
              className="inputDatePicker"
              selected={
                entity?.gameSettings?.mercatoStartDate &&
                new Date(entity.gameSettings.mercatoStartDate)
              }
              onChange={date =>
                dispatch(
                  changeMercatoStartDate({
                    leagueId: entity.id,
                    mercatoStartDate: moment(date).utc().format(),
                  }),
                )
              }
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={30}
              dateFormat="d/M/yyyy hh:mm aa"
              timeCaption="time"
            />
          </div>
        }
      />
      <TableRow
        label="auto mercato"
        value={
          <i
            style={{color: 'black'}}
            onClick={() => {
              if (!entity.gameSettings.autoCloseMercato) {
                dispatch(changeMercatoInAuto({leagueId: entity.id}));
              }
            }}
            className={classNames('fa fa-2x', {
              'fa-toggle-on': entity.gameSettings.autoCloseMercato,
              'fa-toggle-off': !entity.gameSettings.autoCloseMercato,
            })}
          />
        }
      />
      <TableRow
        label="Running divisions"
        value={entity.divisionsIds.map((divisionId, index) => (
          <div
            key={divisionId}
            onClick={() => {
              if (selectedDivision !== divisionId) {
                onSelectDivision(divisionId);
              }
            }}
            style={
              selectedDivision !== divisionId
                ? {
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }
                : {}
            }>
            {index !== 0 ? ` / ${divisionId}` : divisionId}
          </div>
        ))}
      />
    </Fragment>
  );
};

const LiveTableRows = ({entity, onSelectDivision, selectedDivision}) => {
  if (entity.status !== 4) {
    return null;
  }
  return (
    <Fragment>
      <TableRow
        label="Running divisions"
        value={entity.divisionsIds.map((divisionId, index) => (
          <div
            key={divisionId}
            onClick={() => {
              if (selectedDivision !== divisionId) {
                onSelectDivision(divisionId);
              }
            }}
            style={
              selectedDivision !== divisionId
                ? {
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }
                : {}
            }>
            {index !== 0 ? ` / ${divisionId}` : divisionId}
          </div>
        ))}
      />
    </Fragment>
  );
};

const ratings = ['mpg', 'equipe'];
const statuses = {
  1: 'Création',
  2: 'Paiement ultra',
  3: 'Mercato en cours',
  4: 'Live',
  5: 'Saison terminée',
  6: 'En attente',
  7: 'Vente',
};

export const leagueMode = {
  1: 'Normal',
  2: 'Expert',
};

const LeagueInfos = ({
  entity,
  championship,
  dispatch,
  onSelectDivision,
  selectedDivision,
  divisionInfos,
  refreshDivisionInfos,
  leagueUsers,
}) => {
  const championshipName = championship?.lang['fr-FR']?.shortName;
  const imageUrlAction = (
    <div style={UserInfoStyles.avatarActionsContainer}>
      <button
        className="btn btn-warning"
        onClick={() =>
          dispatch(
            setLeagueImageToDefault({
              leagueId: entity.id,
              lockImageUrl: entity.lockedImageUrl,
            }),
          )
        }>
        set to default
      </button>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          marginLeft: 8,
        }}>
        <div>locked</div>
        <input
          style={{minWidth: 0}}
          type="checkbox"
          checked={entity.lockedAvatarUrl}
          onChange={() =>
            dispatch(
              setLeagueImageToDefault({
                leagueId: entity.id,
                lockImageUrl: !entity.lockedImageUrl,
              }),
            )
          }
        />
      </div>
    </div>
  );
  return (
    <div>
      <SupportTitle title="league infos" />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <TableRow label="id" value={entity.id} />
          <TableRow label="admin" value={entity.adminId} />
          <TableRow label="createdAt" value={entity.createdAt} />
          <TableRow label="name" value={entity.name} />
          <TableRow label="description" value={entity.description} />
          <TableRow label="championship" value={championshipName} />
          <TableRow
            label="Avatar"
            value={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}>
                <img
                  style={{maxWidth: 100, marginBottom: 8}}
                  src={entity.imageUrl}
                  alt=""
                />
                <button
                  className="btn btn-info"
                  onClick={() => copyTextToClipboard(entity.imageUrl)}>
                  Copy url
                </button>
              </div>
            }
            action={imageUrlAction}
          />
          {entity?.gameSettings?.championshipId === 1 && (
            <TableRow
              label="rating"
              value={
                <select
                  className="form-control"
                  onChange={e =>
                    dispatch(
                      changeLeagueRating({
                        leagueId: entity.id,
                        rating: e.target.value,
                      }),
                    )
                  }
                  value={entity?.gameSettings?.rating}>
                  {ratings.map(rating => (
                    <option key={rating} value={rating}>
                      {rating}
                    </option>
                  ))}
                </select>
              }
            />
          )}
          <TableRow label="season" value={entity.season} />
          <TableRow label="status" value={statuses[entity.status]} />
          <TableRow
            label="postponed matches"
            value={
              entity?.gameSettings?.considerPostponedMatches ? 'Yes' : 'No'
            }
          />
          <MercatoTableRows
            entity={entity}
            dispatch={dispatch}
            onSelectDivision={onSelectDivision}
            selectedDivision={selectedDivision}
          />
          <LiveTableRows
            entity={entity}
            dispatch={dispatch}
            onSelectDivision={onSelectDivision}
            selectedDivision={selectedDivision}
          />
        </tbody>
      </table>
      <DivisionInfos
        refreshDivisionInfos={refreshDivisionInfos}
        data={
          divisionInfos && {
            ...divisionInfos.division,
            name:
              entity.divisions[
                entity.divisionsIds.indexOf(divisionInfos.division.id) + 1
              ] &&
              entity.divisions[
                entity.divisionsIds.indexOf(divisionInfos.division.id) + 1
              ].name,
          }
        }
      />
      <DivisionPlayers data={divisionInfos && divisionInfos.division} />
      <DivisionPurchases
        leagueId={entity && entity.id}
        divisionInfos={divisionInfos && divisionInfos.division}
      />
      {leagueUsers && entity && (
        <LeagueUsers users={leagueUsers} leagueInfos={entity} />
      )}
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(LeagueInfos);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/LeagueInfo/components/Infos/index.js